// Dubai (Asia/Dubai) has a fixed UTC+4 offset year-round — no DST — so an
// explicit "+04:00" offset on the event's calendar dates is sufficient and
// avoids pulling in a timezone library for this one comparison.

export function festivalPhase(article) {
  if (!article || !article.eventStart || !article.eventEnd) return 'unknown';

  const start = new Date(`${article.eventStart}T00:00:00+04:00`);
  const end = new Date(`${article.eventEnd}T23:59:59+04:00`);
  const now = new Date();

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 'unknown';
  if (now.getTime() < start.getTime()) return 'before';
  if (now.getTime() <= end.getTime()) return 'during';
  return 'after';
}
